import { defineAction } from 'redux-define';

const CANCELLED = 'CANCELLED';
const ERROR = 'ERROR';
const PENDING = 'PENDING';
const SUCCESS = 'SUCCESS';
const USERNAME = 'USERNAME';
const CLEAR = 'CLEAR';

export const SHOW_MODAL = defineAction('OPEN_MODAL', [], 'claro/Profiles');
export const SET_SCREEN = defineAction('SET_SCREEN', [], 'claro/Profiles');

export const LOAD_PROFILES = defineAction(
  'LOAD_PROFILES',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/Profiles',
);

export const LOAD_AVATARS = defineAction(
  'LOAD_AVATARS',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/Profiles',
);

export const UPDATE_PROFILE = defineAction(
  'UPDATE_PROFILE',
  [CANCELLED, ERROR, PENDING, SUCCESS, USERNAME, CLEAR],
  'claro/Profiles',
);

export const DELETE_PROFILE = defineAction(
  'DELETE_PROFILE',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/Profiles',
);

export const ADD_PROFILE = defineAction(
  'ADD_PROFILE',
  [CANCELLED, ERROR, PENDING, SUCCESS, CLEAR],
  'claro/Profiles',
);
